
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.525 16.315h.002V3.658c-.21-.107-2.482-1.919-5.808-2.095l-.555-.028v12.658l.502.024c3.618.173 5.43 1.878 5.86 2.097zM10.582 3.435v12.661c.791-.139 1.967-.291 3.376-.281 2.214.017 3.615.42 4.042.488V3.654c-.174-.02-1.752-.482-4.042-.51-1-.012-2.144.065-3.376.291zm1.582 9.12v-6.19l4.642 3.095-4.642 3.095z"}}),_c('path',{attrs:{"d":"M13.219 8.336v2.248l1.686-1.124-1.686-1.124zM6.684 15.91c-.786-.313-1.815-.579-3.068-.638l-1.507-.073V3.344c-1.212.18-1.86.375-2.109.43v12.69l.655-.164a17.136 17.136 0 016.029-.39z"}})])
          )
        }
      }
    